import { SearchPopper } from "@features/builder/TopActionBar/SearchPopper"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { shortcuts } from "@features/keymap/shortcuts"
import { useKeymap } from "@features/keymap/useKeymap"
import { Search } from "@mui/icons-material"
import { Box, Button, Popper } from "@mui/material"
import { useRef, useState } from "react"

export const Searchbutton = () => {
  const { getKeymaps } = useKeymap()
  const keymap = getKeymaps().byId

  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <KeyBinding
        bind={shortcuts["toggle-search"]}
        onKeyDown={() => setIsSearchVisible((prev) => !prev)}
      />
      <Button
        variant="outlined"
        color="error"
        startIcon={<Search />}
        ref={buttonRef}
        onClick={() => setIsSearchVisible((prev) => !prev)}
        title={keymap.get("toggle-search")?.desc}
      >
        SEARCH
      </Button>
      <Popper open={isSearchVisible} anchorEl={buttonRef.current} placement={"bottom-start"}>
        <Box>
          <SearchPopper onCloseClick={() => setIsSearchVisible(false)} />
        </Box>
      </Popper>
    </>
  )
}
